// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1090":"bbe6d3851523cdd930f3","3492":"91549e53ec6c35e79adc","7662":"06b3fc6c4b38bd3e2e2f"}[chunkId] + ".js";
};